import { css } from '@emotion/css';
import { createPosterBuilder } from 'Shared/posters/project/PosterBuilder';
import { ReadOnlyPoster } from 'Shared/posters/project/PosterRenderer';
import { readThemeDimensions } from 'Shared/model/PosterTheme';


const displayWidth = 300;

const wrapStyle = (width:number,height:number) => css({
	width: displayWidth,
	aspectRatio: `${width} / ${height}`,
	flex: 'none',

	svg: {
		width: '100%',
		height: '100%'
	}
});


export function usesNewPoster(event): boolean
{
	return event.eventType == 'music' && event.imageType == 'auto'
		&& (event.posterNEW?.design?.objects?.length ?? 0) > 0;
}

export function EventPosterSvg(P:{event})
{
	/* The poster measures its text against the DOM, so it renders in the browser only — ReadOnlyPoster
	   holds that gate itself now. */

	const design = () => P.event.posterNEW.design;

	/* themeInfo rides along on the event, so it is missing only where the aggregate could not
	   resolve the theme; the design's own canvas — seeded from that theme — sizes the poster then. */
	const dims = () => P.event.themeInfo
		? readThemeDimensions(P.event.themeInfo.width, P.event.themeInfo.height)
		: design().canvas;

	const builder = createPosterBuilder(
		design,
		undefined,
		undefined,
		() => P.event.themeInfo?.fonts ?? [],
		dims,
		false
	);

	return (
		<div class={wrapStyle(dims().width,dims().height)}>
			<ReadOnlyPoster builder={builder} record={P.event} theme={P.event.themeInfo?.variables} />
		</div>
	);
}
